import * as React from "react";
import styles from "./InfiniteScroller.module.scss"

const InfiniteScroller = (props) => {
  const ref = React.useRef()

  React.useEffect(() => {
    if(ref.current.clientHeight + ref.current.scrollTop >= ref.current.scrollHeight) {
      props.onFetchData()
    }
  }, [props.children])

  const handleScroll = (e) => {
    if (e.target.clientHeight + e.target.scrollTop >= e.target.scrollHeight) {
      props.onFetchData()
    }
  }

  return (
    <div ref={ref} onScroll={handleScroll} className={styles.infiniteScroller} style={{maxHeight: props.maxHeight}}>
      { props.children }
    </div>
  )
}

export default InfiniteScroller